import { apiRequest } from './core/client';
import { SignatureSchema, parseWithSchema, parseArrayWithSchema, type Signature } from './schemas';

export type { Signature };

// ============================================================================
// Signature Operations
// ============================================================================

export interface SignaturePayload {
  name: string;
  html: string;
}

export async function fetchSignatures(): Promise<Signature[]> {
  const data = await apiRequest<unknown[]>({
    path: '/signatures',
  });
  return parseArrayWithSchema(SignatureSchema, data, 'fetchSignatures');
}

export async function createSignature(payload: SignaturePayload): Promise<Signature> {
  const data = await apiRequest<unknown>({
    path: '/signatures',
    method: 'POST',
    body: payload,
  });
  return parseWithSchema(SignatureSchema, data, 'createSignature');
}

export async function updateSignature(
  signatureId: string,
  payload: Partial<SignaturePayload>
): Promise<Signature> {
  const data = await apiRequest<unknown>({
    path: `/signatures/${encodeURIComponent(signatureId)}`,
    method: 'PUT',
    body: payload,
  });
  return parseWithSchema(SignatureSchema, data, 'updateSignature');
}

export async function deleteSignature(signatureId: string): Promise<Signature> {
  const data = await apiRequest<unknown>({
    path: `/signatures/${encodeURIComponent(signatureId)}`,
    method: 'DELETE',
  });
  return parseWithSchema(SignatureSchema, data, 'deleteSignature');
}
